import Turbolinks from 'turbolinks';

/**
 * https://github.com/turbolinks/turbolinks/issues/17#issuecomment-230169838
 * html syntax from https://mdbootstrap.com/components/progress-bars/
 */
Turbolinks.ProgressBar.defaultCSS = ""

Turbolinks.ProgressBar.prototype.installProgressElement = function() {
  let transparent = '';
  if ($('#sidenav-overlay').css('opacity') == 1) {
    transparent = 'background-color: transparent !important'
  }
  let mdbProgressCircle = `<div class='js-page-loader'><div id='mdb-preloader' class='flex-center' style='${transparent}'>\
    <div id='preloader-markup'>\
    <div class='preloader-wrapper active'>\
    <div class='spinner-layer spinner-white-only'>\
    <div class='circle-clipper left'>\
    <div class='circle'></div>\
    </div><div class='gap-patch'>\
    <div class='circle'></div>\
    </div><div class='circle-clipper right'>\
    <div class='circle'></div>\
    </div></div></div></div></div></div>`

  return $('body').prepend($(mdbProgressCircle));
}

Turbolinks.ProgressBar.prototype.uninstallProgressElement = function() {
  $('.js-page-loader').remove();
}

/**
 * Any less than a second and the overlay looked more like a flash on the screen
 * and was annoying.
 */
Turbolinks.BrowserAdapter.prototype.showProgressBarAfterDelay = function() {
  return this.progressBarTimeout = setTimeout(this.showProgressBar, 1000);
};
